import{DEFAULT_GRADIENTS as n}from"../components/GradientManager/configuration/constants.js";var o={DEFAULT_GRADIENTS:n};export{o as componentsSettings};
